
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

interface FAQItem {
  question: string;
  answer: string;
}

interface CidadeFAQProps {
  faqItems: FAQItem[];
  cidadeFormatted: string;
  estadoNome: string;
}

const CidadeFAQ = ({ faqItems, cidadeFormatted, estadoNome }: CidadeFAQProps) => {
  return (
    <section className="py-16 px-6 md:px-12 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold mb-8 text-seo-dark text-center">
          Perguntas Frequentes sobre SEO em {cidadeFormatted}
        </h2>
        
        <div className="bg-gray-50 p-8 rounded-lg shadow-sm">
          <Accordion type="single" collapsible className="w-full">
            {faqItems.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left font-semibold text-seo-dark">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-700">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default CidadeFAQ;
